/**
 * WordPress dependencies
 */
import { _x } from '@safe-wordpress/i18n';

/**
 * Formats font styles to human readable names.
 *
 * @param {string} fontStyle font style string
 * @return {Object} new object with formatted font style
 */
export function formatFontStyle( fontStyle: string ): {
	name?: string;
	value?: string;
} {
	if ( ! fontStyle ) {
		return {};
	}

	if ( typeof fontStyle === 'object' ) {
		return fontStyle;
	}

	let name;

	switch ( fontStyle ) {
		case 'normal':
			name = _x( 'Regular', 'font style', 'nelio-ab-testing' );
			break;
		case 'italic':
			name = _x( 'Italic', 'font style', 'nelio-ab-testing' );
			break;
		case 'oblique':
			name = _x( 'Oblique', 'font style', 'nelio-ab-testing' );
			break;

		default:
			name = fontStyle;
			break;
	}

	return { name, value: fontStyle };
}
